import axios from "axios";
export const BASE_URL = "https://financeapi.taysirsolutions.net/";
// export const BASE_URL = "https://beobble.a2development.org/";
// export const BASE_URL = "https://localhost:5001/";
export const AXIOS = axios.create({ baseURL: BASE_URL + "api/" });
